/**
 * The banner that keeps a scenario honest.
 *
 * A tool that answers "what would happen if" has exactly one way to be
 * dangerous: letting someone read a hypothetical as the plan. Every number on
 * both tabs changes under a scenario, and none of them looks any different — so
 * the state has to be stated, permanently and in the reader's way, with the exit
 * next to it.
 *
 * The count is computed against what is STORED, not tracked as a tally, so
 * moving a customer and moving it back reads "no changes" rather than "2".
 */
import { Button } from '@andavo/web-ui';

export function ScenarioBar({
  changes,
  onReset,
}: {
  changes: number;
  onReset: () => void;
}) {
  if (changes === 0) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-3 rounded-md border border-content-warning bg-surface-midground px-3 py-2"
      data-testid="staffing-scenario-bar"
      role="status"
    >
      <span className="font-medium text-content-warning text-sm">
        What-if: {changes} {changes === 1 ? 'change' : 'changes'}
      </span>
      <span className="text-content-secondary text-sm">
        Every figure below is computed from this scenario. Nothing is saved.
      </span>
      <Button onClick={onReset} size="sm" variant="secondary">
        Discard scenario
      </Button>
    </div>
  );
}
